import { atom } from "recoil"
import { GroupMember } from "src/types/organization/group/GroupMember"

export const deletedMemberIdsState = atom<Set<GroupMember["id"]>>({
  key: "atoms/organization/group/deletedMemberIdsState",
  default: new Set(),
})
